import { faCheck, faCopy } from '@fortawesome/free-solid-svg-icons'
import { Button, ButtonTypeMap } from '@mui/material'
import { useI18N } from '@tm/client-form/src/hooks/useI18n'
import { FontAwesomeSvgIcon } from '@tm/ui/composite/FontAwesomeSvgIcon'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useCopyToClipboard } from 'usehooks-ts'

export const CopyButton = ({
  text,
  color,
  onCopy,
}: {
  text: string
  color?: ButtonTypeMap['props']['color']
  onCopy?: () => void
}) => {
  const { t } = useI18N()
  const [hasCopied, setHasCopied] = useState(false)
  const [, copy] = useCopyToClipboard()
  const timerRef = useRef<ReturnType<typeof setTimeout>>()
  const handleCopy = useCallback(() => {
    void copy(text)
    setHasCopied(true)
    timerRef.current = setTimeout(() => setHasCopied(false), 5000)
    if (onCopy) onCopy()
  }, [text, copy, onCopy])

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  return (
    <Button
      data-testid="copy-button"
      variant="contained"
      size="small"
      color={hasCopied ? 'success' : color ?? 'secondary'}
      onClick={handleCopy}
      startIcon={<FontAwesomeSvgIcon icon={hasCopied ? faCheck : faCopy} />}>
      {t('copyButton.copy')}
    </Button>
  )
}
